import { LeaderboardCountdown } from "../common/LeaderboardCountdown";
import styles from "./styles.module.css";

interface IHeaderTitleProps {
  title: string;
  subtitle?: string;
  countdownProps?: {
    showCountdown?: boolean;
    lastUpdatedAt?: number;
  };
}

export function HeaderTitle({
  title,
  subtitle,
  countdownProps,
}: IHeaderTitleProps) {
  return (
    <div className={styles.titleWrapper}>
      <p className={styles.title}>{title}</p>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {countdownProps?.showCountdown && (
        <LeaderboardCountdown
          lastUpdatedAt={countdownProps?.lastUpdatedAt ?? 0}
        />
      )}
    </div>
  );
}
